export const INTENTION_GETTING_START = 'INTENTION_GETTING_START';
export const INTENTION_GETTING_IN_PROGRESS = 'INTENTION_GETTING_IN_PROGRESS';
export const INTENTION_GETTING_SUCCESS = 'INTENTION_GETTING_SUCCESS';
export const INTENTION_GETTING_FAILURE = 'INTENTION_GETTING_FAILURE';
